/**
 * Application Configuration
 * Environment-specific settings for RB's Daily Planner
 */

interface AppConfig {
  // API Configuration
  apiUrl: string;
  apiTimeout: number;
  
  // Environment
  environment: string;
  isDevelopment: boolean;
  isProduction: boolean;
  
  // Application Info
  appName: string;
  appVersion: string;
  companyName: string;
  
  // Feature Flags (for future use)
  features: {
    analytics: boolean;
    notifications: boolean;
    exportCsv: boolean;
  };
}
//console.log('🔍 DEBUG - process.env.REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
//console.log('🔍 DEBUG - process.env.NODE_ENV:', process.env.NODE_ENV);
//console.log('🔍 DEBUG - All REACT_APP vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));

const config: AppConfig = {
  // API Configuration
  apiUrl: process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || 'http://localhost:8001',
  apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
  
  // Environment
  environment: process.env.REACT_APP_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // Application Info
  appName: "Yojana",
  appVersion: '1.0.0',
  companyName: 'WiseWit.ai',
  
  // Feature Flags
  features: {
    analytics: true,
    notifications: true,
    exportCsv: true,
  },
};

// Validation
if (!config.apiUrl) {
  throw new Error('REACT_APP_API_URL environment variable is not set');
}

// Log config in development (helps debugging)
if (config.isDevelopment) {
  console.log('🔧 Application Configuration:', {
    apiUrl: config.apiUrl,
    environment: config.environment,
    features: config.features,
  });
}

// Freeze config to prevent accidental modifications
Object.freeze(config);
Object.freeze(config.features);

export default config;
